import { AllRfqThemeModeConfig } from './types';

const light: AllRfqThemeModeConfig = {
  allRfq: {},
};

export default light;
